// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"c9d44016","668":"41df96d5","838":"bfb0be2e"}[chunkId] + ".js";
};